const DropdownOption = {
    baseStyle: {
        _focus: {
            outlineOffset: '4px',
        },
        alignItems: 'center',
        borderRadius: '8px',
        cursor: 'pointer',
        display: 'grid',
        fontSize: 'lg',
        fontWeight: 400,
        gridColumnGap: '20px',
        h: '48px',
        input: {
            clip: 'rect(1px, 1px, 1px, 1px)',
            height: 1,
            overflow: 'hidden',
            position: 'absolute !important',
            width: 1,
        },
        label: {
            fontWeight: 400,
            lineHeight: '48px',
            m: 0,
        },
        lineHeight: '24px',
        m: '1px 0',
        p: '0 16px 0 16px',
        transition: 'background-color 0.2s ease-in-out',
    },
};
export default DropdownOption;
